import { render, staticRenderFns } from "./storeRevenueData.vue?vue&type=template&id=dd0899d2&scoped=true&"
import script from "./storeRevenueData.vue?vue&type=script&lang=js&"
export * from "./storeRevenueData.vue?vue&type=script&lang=js&"
import style0 from "./storeRevenueData.vue?vue&type=style&index=0&id=dd0899d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0899d2",
  null
  
)

export default component.exports